// // src/models/EditProfileModal.jsx
// import React, { useState, useEffect } from "react";
// import { toast } from "react-toastify";
// import axios from "axios";
// import CameraAltIcon from "@mui/icons-material/CameraAlt";

// const API_BASE = "http://localhost:5000/api/auth";

// export default function EditProfileModal({
//   onClose,
//   embedded,
//   onBack,
//   user: initialUser,
//   setUser,
// }) {
//   const [formData, setFormData] = useState({
//     name: "",
//     firmName: "",
//     email: "",
//     address: "",
//     profileImage: "",
//   });
//   const [imagePreview, setImagePreview] = useState("");
//   const [saving, setSaving] = useState(false);

//   useEffect(() => {
//     if (initialUser) {
//       setFormData({
//         name: initialUser.name || "",
//         firmName: initialUser.firmName || "",
//         email: initialUser.email || "",
//         address: initialUser.address || "",
//         profileImage: initialUser.profileImage || "",
//       });
//       setImagePreview(initialUser.profileImage || "");
//     }
//   }, [initialUser]);

//   const handleImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         const base64 = reader.result;
//         setImagePreview(base64);
//         setFormData((prev) => ({ ...prev, profileImage: base64 }));
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const handleSave = async () => {
//     setSaving(true);
//     try {
//       const dealer = JSON.parse(localStorage.getItem("dealer"));
//       const res = await axios.put(`${API_BASE}/dealer/${dealer.id}`, formData);

//       if (res.data.success) {
//         const updatedUser = res.data.dealer;
//         setUser(updatedUser);
//         localStorage.setItem("dealer", JSON.stringify(updatedUser));
//         toast.success("Profile updated successfully!");
//         if (embedded && onBack) onBack();
//         else if (onClose) onClose();
//       }
//     } catch (err) {
//       toast.error(err.response?.data?.message || "Failed to update profile");
//     } finally {
//       setSaving(false);
//     }
//   };

//   const handleCancel = () => {
//     if (embedded && onBack) onBack();
//     else if (onClose) onClose();
//   };

//   return (
//     <>
//       {embedded ? (
//         <div className="bg-white rounded-3xl shadow-2xl p-10">
//           <div className="flex justify-end mb-4">
//             <button onClick={onBack} className="text-gray-500 hover:text-gray-800 text-4xl">
//               ×
//             </button>
//           </div>

//           <div className="flex justify-center mb-10">
//             <label className="relative cursor-pointer group">
//               <input type="file" accept="image/*" onChange={handleImageChange} className="hidden" />
//               {imagePreview ? (
//                 <img src={imagePreview} alt="Profile" className="w-40 h-40 rounded-full object-cover border-8 border-yellow-400 shadow-2xl" />
//               ) : (
//                 <div className="w-40 h-40 rounded-full bg-gray-200 border-8 border-dashed border-gray-400 flex items-center justify-center text-6xl text-gray-400">
//                   ?
//                 </div>
//               )}
//               <div className="absolute inset-0 rounded-full bg-black bg-opacity-40 opacity-0 group-hover:opacity-100 transition flex items-center justify-center">
//                 <CameraAltIcon sx={{ fontSize: 40, color: "white" }} />
//               </div>
//             </label>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
//             <InputField label="Full Name" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} />
//             <InputField label="Firm Name" value={formData.firmName} onChange={(e) => setFormData({ ...formData, firmName: e.target.value })} />
//             <InputField label="Email Address" type="email" value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })} />
//             <InputField label="Contact Number" value={initialUser?.phone || "N/A"} disabled />
//           </div>

//           <div className="max-w-4xl mx-auto mt-6">
//             <label className="block text-lg font-semibold text-gray-700 mb-3">Business Address</label>
//             <textarea
//               rows="4"
//               className="w-full px-6 py-4 border-2 border-gray-300 rounded-2xl focus:border-yellow-500 focus:ring-4 focus:ring-yellow-100 outline-none transition text-lg"
//               value={formData.address}
//               onChange={(e) => setFormData({ ...formData, address: e.target.value })}
//               placeholder="Enter your complete business address..."
//             />
//           </div>

//           <div className="flex gap-6 max-w-4xl mx-auto mt-10">
//             <button
//               onClick={handleSave}
//               disabled={saving}
//               className="flex-1 bg-yellow-500 text-white py-5 rounded-2xl font-bold text-xl hover:bg-yellow-600 transition shadow-lg disabled:opacity-70"
//             >
//               {saving ? "Saving..." : "Save Changes"}
//             </button>
//             <button
//               onClick={handleCancel}
//               className="flex-1 bg-gray-200 text-gray-800 py-5 rounded-2xl font-bold text-xl hover:bg-gray-300 transition"
//             >
//               Cancel
//             </button>
//           </div>
//         </div>
//       ) : (
//         /* Popup mode remains unchanged */
//         <div>...</div>
//       )}
//     </>
//   );
// }

// const InputField = ({ label, ...props }) => (
//   <div>
//     <label className="block text-sm font-medium text-gray-700 mb-2">{label}</label>
//     <input
//       className="w-full px-5 py-4 border-2 border-gray-300 rounded-xl focus:border-yellow-500 focus:ring-4 focus:ring-yellow-100 outline-none transition text-lg"
//       {...props}
//     />
//   </div>
// );

import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import { API_BASE as API_ORIGIN } from "../utils/api";

const API_BASE = `${API_ORIGIN}/api/auth`;

export default function EditProfileModal({
  onClose,
  embedded,
  onBack,
  user: initialUser,
  setUser,
}) {
  const [formData, setFormData] = useState({
    name: "",
    firmName: "",
    email: "",
    address: "",
    profileImage: "",
  });
  const [imagePreview, setImagePreview] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (initialUser) {
      setFormData({
        name: initialUser.name || "",
        firmName: initialUser.firmName || "",
        email: initialUser.email || "",
        address: initialUser.address || "",
        profileImage: initialUser.profileImage || "",
      });
      setImagePreview(initialUser.profileImage || "");
    }
  }, [initialUser]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64 = reader.result;
        setImagePreview(base64);
        setFormData((prev) => ({ ...prev, profileImage: base64 }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      const dealer = JSON.parse(localStorage.getItem("dealer"));
      const res = await axios.put(`${API_BASE}/dealer/${dealer.id}`, formData);

      if (res.data.success) {
        const updatedUser = res.data.dealer;
        if (setUser) setUser(updatedUser);
        localStorage.setItem("dealer", JSON.stringify(updatedUser));
        toast.success("Profile updated successfully!");
        if (embedded && onBack) onBack();
        else if (onClose) onClose();
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to update profile");
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    if (embedded && onBack) onBack();
    else if (onClose) onClose();
  };

  return (
    <div className="bg-white rounded-3xl shadow-2xl p-6 md:p-10">
      <div className="flex justify-between items-start mb-4">
        <h2 className="text-2xl md:text-3xl font-bold">Edit Profile</h2>
        {embedded && (
          <button
            onClick={onBack}
            className="text-gray-500 hover:text-gray-800 text-2xl md:text-4xl"
          >
            ×
          </button>
        )}
      </div>

      <div className="flex justify-center mb-6 md:mb-10">
        <label className="relative cursor-pointer group">
          <input
            type="file"
            accept="image/*"
            onChange={handleImageChange}
            className="hidden"
          />
          {imagePreview ? (
            <img
              src={imagePreview}
              alt="Profile"
              className="w-28 h-28 md:w-40 md:h-40 rounded-full object-cover border-4 border-yellow-400 shadow-2xl"
            />
          ) : (
            <div className="w-28 h-28 md:w-40 md:h-40 rounded-full bg-gray-200 border-4 border-dashed border-gray-400 flex items-center justify-center text-4xl md:text-6xl text-gray-400">
              ?
            </div>
          )}
          <div className="absolute inset-0 rounded-full bg-black bg-opacity-40 opacity-0 group-hover:opacity-100 transition flex items-center justify-center">
            <CameraAltIcon sx={{ fontSize: 28, color: "white" }} />
          </div>
        </label>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-4xl mx-auto">
        <InputField
          label="Full Name"
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
        />
        <InputField
          label="Firm Name"
          value={formData.firmName}
          onChange={(e) =>
            setFormData({ ...formData, firmName: e.target.value })
          }
        />
        <InputField
          label="Email Address"
          type="email"
          value={formData.email}
          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
        />
        <InputField
          label="Contact Number"
          value={initialUser?.phone || "N/A"}
          disabled
        />
      </div>

      <div className="max-w-4xl mx-auto mt-4 md:mt-6">
        <label className="block text-lg font-semibold text-gray-700 mb-2">
          Business Address
        </label>
        <textarea
          rows="4"
          className="w-full px-4 py-3 border-2 border-gray-300 rounded-2xl focus:border-yellow-500 focus:ring-4 focus:ring-yellow-100 outline-none transition text-base md:text-lg"
          value={formData.address}
          onChange={(e) =>
            setFormData({ ...formData, address: e.target.value })
          }
          placeholder="Enter your complete business address..."
        />
      </div>

      <div className="flex flex-col md:flex-row gap-3 max-w-4xl mx-auto mt-6">
        <button
          onClick={handleSave}
          disabled={saving}
          className="flex-1 bg-yellow-500 text-white py-3 md:py-4 rounded-2xl font-bold text-lg hover:bg-yellow-600 transition disabled:opacity-70"
        >
          {saving ? "Saving..." : "Save Changes"}
        </button>
        <button
          onClick={handleCancel}
          className="flex-1 bg-gray-200 text-gray-800 py-3 md:py-4 rounded-2xl font-bold text-lg hover:bg-gray-300 transition"
        >
          Cancel
        </button>
      </div>
    </div>
  );
}

const InputField = ({ label, ...props }) => (
  <div>
    <label className="block text-sm md:text-base font-medium text-gray-700 mb-1">
      {label}
    </label>
    <input
      className="w-full px-4 py-3 border-2 border-gray-300 rounded-xl focus:border-yellow-500 focus:ring-4 focus:ring-yellow-100 outline-none transition text-base"
      {...props}
    />
  </div>
);
